// extracted by mini-css-extract-plugin
export default {"about":"About_about__U6j+1","wrapper":"About_wrapper__dP8ai","awardsInner":"About_awardsInner__vRizi","awards":"About_awards__rxPcs"};